<template>
    <div :class="{'c-split-btn':dropdown.length > 0}">

        <button v-if="!dropDownOnly" type="button" class="c-btn c-btn--small no-margin" :class="[setStyle, {'c-btn--hollow' : hollow}]" @click.prevent="mainbutton.action">
            {{mainbutton.label}}
        </button>

        <button v-if="dropdown.length > 0" class="c-btn c-btn--small no-margin" :class="[setStyle, {'c-btn--hollow' : hollow}]" @click="active = !active" v-click-outside="closeSplitBtnDropdown">
            <span v-if="buttonText && buttonText.length > 0">
                {{buttonText}}
            </span>
            <svg v-else xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><defs><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" id="more"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#more"/></svg>
        </button>

        <div class="c-split-btn__dropdown" :class="{'c-split-btn__dropdown--primary' : this.style === 'primary' }" v-if="active && dropdown.length > 0">
            <ul class="c-list-dropdown">
                <li v-for="(button, index) in dropdown" :key="'dropdown-item-' + index"><a href="#" @click="button.action" class="fs-small">{{button.label}}</a></li>
            </ul>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        buttons: {
            type: Array,
            required: true
        },
        style: {
            type: String,
            required: false
        },
        hollow: {
            type: Boolean,
            default: true
        },
        buttonText: {
            type: String,
            required: false
        },
        dropDownOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            active: false
        }
    },
    computed: {
        mainbutton() {
            return this.buttons.slice(0,1)[0];
        },
        dropdown() {

            if (this.buttonText) {
                return this.buttons;
            }

            return this.buttons.slice(1);
        },
        setStyle() {
            if (this.style === 'primary') {
                return 'c-btn--primary';
            } else if (this.style === 'warning') {
                return 'c-btn--warning';
            } else {
                return 'c-btn--secondary';
            }
        }

    },
    methods: {
        closeSplitBtnDropdown() {
            if (this.active === true) {
                this.active = false;
            }
        }
    }
}
</script>
